import { DayOfWeek } from './Adjustment';
import GenericDataType from './GenericDataType';

export default interface ReserveCapacity
  extends CreateReserveCapacityRequest,
    GenericDataType {
  status: ReserveCapacityStatus;
}

export enum ReserveCapacityStatus {
  Active = 'ACTIVE',
  Next = 'NEXT',
  Ended = 'ENDED'
}

export interface CreateReserveCapacityRequest {
  area: string;
  capacityType: string;
  startDate: string;
  endDate: string;
  percentage: number;
  releaseAt: number;
  days: DayOfWeek[];
}

export interface EditReserveCapacityRequest
  extends GenericDataType,
    CreateReserveCapacityRequest {}
